import type { SupSingleVaultV3 } from "@/types";
import { SPECIAL_POINT_PROTOCOLS } from "@/components/Ui/Label/Rewards/constant";

export function isSpecialPointReward(vault: SupSingleVaultV3) {
  const isSupervault = vault.is_supervault;
  const isSuperProtocol = isSpecialPointRewardByProtocol(vault.protocol ?? vault.protocol_id);
  console.log("isSpecialPointReward", { vault, isSuperProtocol, isSupervault, result: isSupervault || isSuperProtocol });
  return isSupervault || isSuperProtocol;
}

export function isSpecialPointRewardByProtocol(protocol: { id: string } | string | undefined | null) {
  return !!protocol && SPECIAL_POINT_PROTOCOLS.includes(typeof protocol === "string" ? protocol : protocol.id);
}
